import { useState, useEffect } from 'react';
import AdminShell from '../../components/admin/AdminShell';
import { useToast } from '../../context/ToastContext';
import api from '../../utils/api';

const AdminSupportPage = () => {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('open');
  const { success, error } = useToast();

  useEffect(() => { loadTickets(); }, [filter]);

  const loadTickets = async () => {
    setLoading(true);
    try {
      const res = await api.get('/admin/support', { params: { status: filter } });
      setTickets(res.data.data || []);
    } catch { setTickets([]); }
    finally { setLoading(false); }
  };

  const STATUS = {
    open: { bg: '#FEF3C7', color: '#7C2D12', label: 'Open' },
    in_progress: { bg: '#EFF6FF', color: '#2563EB', label: 'In Progress' },
    resolved: { bg: '#E6F4EC', color: '#1B7F3E', label: 'Resolved' }
  };

  return (
    <AdminShell title="Support Tickets" subtitle="Student queries and issues">
      <div style={{ background: 'white', border: '1px solid #E2E8F0', borderRadius: '14px', padding: '16px' }}>
        <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
          {[['open', 'Open'], ['in_progress', 'In Progress'], ['resolved', 'Resolved']].map(([val, lbl]) => (
            <button key={val} onClick={() => setFilter(val)}
              style={{ padding: '5px 14px', borderRadius: '20px', fontSize: '11px', fontWeight: 700, border: filter === val ? 'none' : '1px solid #E2E8F0', background: filter === val ? '#1A3C6E' : 'white', color: filter === val ? 'white' : '#64748B', cursor: 'pointer' }}>
              {lbl}
            </button>
          ))}
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px' }}><div className="spinner" style={{ margin: '0 auto' }}></div></div>
        ) : tickets.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '48px', color: '#64748B' }}>
            <div style={{ fontSize: '48px', marginBottom: '12px' }}>💬</div>
            <div style={{ fontWeight: 700 }}>No {filter} tickets</div>
            <div style={{ fontSize: '12px', marginTop: '4px' }}>Student support tickets will appear here</div>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {tickets.map(t => {
              const badge = STATUS[t.status] || STATUS.open;
              return (
                <div key={t.id} style={{ border: '1px solid #E2E8F0', borderRadius: '10px', padding: '14px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                    <div style={{ fontSize: '13px', fontWeight: 800 }}>{t.subject}</div>
                    <span style={{ fontSize: '10px', fontWeight: 800, background: badge.bg, color: badge.color, borderRadius: '20px', padding: '2px 8px', whiteSpace: 'nowrap', marginLeft: '8px' }}>{badge.label}</span>
                  </div>
                  <div style={{ fontSize: '12px', color: '#64748B', lineHeight: 1.5, marginBottom: '8px' }}>{t.message}</div>
                  <div style={{ fontSize: '10px', color: '#94A3B8' }}>
                    Submitted {new Date(t.created_at).toLocaleString('en-IN')}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </AdminShell>
  );
};

export default AdminSupportPage;
